export default {"src":"/_next/static/media/extension.80b779a4.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};